import { LocalizedTypography, OptimusProvider, OverlayedLoader } from '@mews-commander/ui';
import { CommanderFormProps } from '@mews-commander/form';
import { RefundMode, SinglePaymentParameters } from '@mews-commander/data-access';
import { Stack } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { WithAccountId } from '@mews-commander/types';
import { useGetPaymentRefundInitialValuesSuspense } from '../../../queries';
import { PaymentRefundDetails } from './paymentRefundDetails/PaymentRefundDetails';
import { PaymentRefundForm } from './paymentRefundForm/PaymentRefundForm';
import { PaymentRefundWithFXForm } from './paymentRefundForm/PaymentRefundWithFXForm';
import { getNormalizedData } from './utils';

export const PaymentRefundDialog = ({
    paymentId,
    ...formProps
}: SinglePaymentParameters & CommanderFormProps & WithAccountId) => {
    const { data, isFetching } = useGetPaymentRefundInitialValuesSuspense({ paymentId });

    const isRefundWithFX = !!data.foreignExchangePaymentDetail;
    const normalizedData = getNormalizedData(data);

    if (isFetching) {
        return <OverlayedLoader show />;
    }

    return (
        <Stack vertical spacing="300">
            <LocalizedTypography
                textStyle="bodyMediumStrong"
                variant="secondary"
                textKey={
                    data.refundMode === RefundMode.InPerson
                        ? TextKey.InPersonPaymentRefundFormInfo
                        : TextKey.OnlinePaymentRefundFormInfo
                }
                as="div"
            />
            <PaymentRefundDetails {...normalizedData} isRefundWithFX={isRefundWithFX} />
            <OptimusProvider density="spacious">
                {isRefundWithFX ? (
                    <PaymentRefundWithFXForm paymentId={paymentId} data={normalizedData} {...formProps} />
                ) : (
                    <PaymentRefundForm paymentId={paymentId} data={normalizedData} {...formProps} />
                )}
            </OptimusProvider>
        </Stack>
    );
};
